import React from "react";

const Footer = () => {
  return (
    <div className="footer flex absolute-center max-width">
      Made with 🤍 by Deep Poharkar FY21M1351
    </div>
  );
};

export default Footer;
